/**
 * 阿里云 OSS 视频直传公共方法
 * 图片仍走业务旧接口，视频通过 base/policy 获取签名后直传 OSS
 */
export default {
  methods: {
    isVideoFile(file) {
      if (!file) return false
      if (file.type && file.type.indexOf('video/') === 0) return true
      const name = file.name || ''
      return /\.(mp4|mov|avi|wmv|flv|mkv|webm|m4v)$/i.test(name)
    },
    isVideoUrl(url) {
      if (!url) return false
      const pureUrl = String(url).split('?')[0]
      return /\.(mp4|mov|avi|wmv|flv|mkv|webm|m4v)$/i.test(pureUrl)
    },
    generateUuid() {
      if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID()
      }
      return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
    },
    getOssPolicy() {
      return this.getHttpServices().getBaseService().post('base/policy')
    },
    async uploadVideoToOss(file) {
      const policyData = await this.getOssPolicy()
      const suffix = file.name.substring(file.name.lastIndexOf('.'))
      const key = `${policyData.dir || ''}${this.generateUuid()}${suffix}`
      const formData = new FormData()
      formData.append('key', key)
      formData.append('OSSAccessKeyId', policyData.accessKeyId)
      formData.append('policy', policyData.policy)
      formData.append('Signature', policyData.signature)
      formData.append('success_action_status', '200')
      formData.append('file', file)

      const uploadRes = await fetch(policyData.host, {
        method: 'POST',
        body: formData
      })
      if (!uploadRes.ok) {
        throw new Error(`OSS上传失败 status:${uploadRes.status}`)
      }
      const host = String(policyData.host || '').replace(/\/$/, '')
      return `${host}/${key}`
    },
    validateVideoSize(file, maxVideoSize = 200) {
      const isLtMax = file.size / 1024 / 1024 < maxVideoSize
      if (!isLtMax) {
        this.$message.error(`上传的视频不能大于${maxVideoSize}M!`)
        return false
      }
      return true
    },
    async handleOssVideoUpload(file, onSuccess, loadingKey = 'videoUploading') {
      this[loadingKey] = true
      try {
        const fileUrl = await this.uploadVideoToOss(file)
        if (onSuccess) {
          onSuccess(fileUrl, file)
        }
        this.$message.success('视频上传成功')
      } catch (err) {
        this.getLogUtils().logWithTag('handleVideoUpload', err)
        this.$message.error((err && err.msg) || err.message || '视频上传失败，请重试')
      } finally {
        this[loadingKey] = false
      }
    }
  }
}
